import React, {ChangeEvent} from 'react';
import {FormControl, InputLabel, MenuItem, Select, Stack, TextField, Tooltip} from '@mui/material';
import {PaymentAdviceFiltersResponse, PaymentAdvicesRequest} from "../../api/PaymentAdviceApi";
import styles from './PaymentAdvice.module.css';

interface PaymentAdviceFiltersProps {
    filters: PaymentAdviceFiltersResponse | undefined;
    request: PaymentAdvicesRequest;
    onFilterChange: (key: keyof PaymentAdvicesRequest) => (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | any) => void;
}

const PaymentAdviceFilters: React.FC<PaymentAdviceFiltersProps> = ({
                                                                       filters,
                                                                       request,
                                                                       onFilterChange
                                                                   }) => {
    return (
        <Stack className={styles.filtersContainer}>
            <TextField
                label="Search"
                value={request.search ?? ''}
                placeholder="Search..."
                onChange={onFilterChange('search')}
                slotProps={{inputLabel: {shrink: true}}}
                className={styles.searchField}
            />
            <FormControl className={styles.merchantSelect}>
                <InputLabel>Merchant</InputLabel>
                <Select
                    label="Merchant"
                    value={request.merchantAccount ?? ''}
                    onChange={onFilterChange('merchantAccount')}
                >
                    <MenuItem value="">All</MenuItem>
                    {filters?.merchantAccounts.map(s => (
                        <MenuItem key={s} value={s}>{s}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={styles.currencySelect}>
                <InputLabel>Currency</InputLabel>
                <Select
                    label="Currency"
                    value={request.currency ?? ''}
                    onChange={onFilterChange('currency')}
                    MenuProps={{
                        PaperProps: {
                            className: styles.currencyMenu,
                        },
                    }}
                >
                    <MenuItem value="">All</MenuItem>
                    {filters?.currencies.map(c => (
                        <MenuItem key={c} value={c}>{c}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <Tooltip title="Transaction Date From">
                <TextField
                    type="date"
                    label="Transaction Date From"
                    value={request.transactionDateFrom ?? ''}
                    onChange={onFilterChange('transactionDateFrom')}
                    slotProps={{ inputLabel: { shrink: true } }}
                />
            </Tooltip>
            <Tooltip title="Transaction Date To">
                <TextField
                    type="date"
                    label="Transaction Date To"
                    value={request.transactionDateTo ?? ''}
                    onChange={onFilterChange('transactionDateTo')}
                    slotProps={{inputLabel: {shrink: true}}}
                />
            </Tooltip>
            <Tooltip title="Report Date">
                <TextField
                    type="date"
                    label="Report Date"
                    value={request.reportDate ?? ''}
                    onChange={onFilterChange('reportDate')}
                    slotProps={{inputLabel: {shrink: true}}}
                />
            </Tooltip>
            <FormControl className={styles.typeSelect}>
                <InputLabel>Type</InputLabel>
                <Select
                    label="Type"
                    value={request.financialTransactionType ?? ''}
                    onChange={onFilterChange('financialTransactionType')}
                >
                    <MenuItem value="">All</MenuItem>
                    {filters?.types.map(s => (
                        <MenuItem key={s} value={s}>{s}</MenuItem>
                    ))}
                </Select>
            </FormControl>
            <FormControl className={styles.statusSelect}>
                <InputLabel>Status</InputLabel>
                <Select
                    label="Status"
                    value={request.status ?? ''}
                    onChange={onFilterChange('status')}
                >
                    <MenuItem value="">All</MenuItem>
                    {filters?.statuses.map(s => (
                        <MenuItem key={s} value={s}>{s}</MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Stack>
    );
};

export default PaymentAdviceFilters;
